import configs from "../configs/apiConfigs";
import { BODY_TYPE, CommonApiOptions, METHOD_TYPE } from "../constants/api";
import { commonApi } from "../helpers/api";
import { attachHeader } from "../utils/apiHandlers";

export const appointmentDetail = (pUniqueId: any) => {
    const request: CommonApiOptions = {
        // url: configs.API_URL + "patient/" + pUniqueId + "/appointment/details/",
        url: configs.API_URL + "getappointment/" + pUniqueId +"/" ,
        apiOptions: {
            headers: attachHeader(true),
            withCredentials: true
        },
        method: METHOD_TYPE.GET
    };
    return commonApi(request);
};

export const chatNotificationProvider = (providerId: number, data: any) => {
    const request: CommonApiOptions = {
        url: configs.API_URL + 'chatNotificationProvider/' + providerId + '/',
        method: METHOD_TYPE.POST,
        body: {
            type: BODY_TYPE.RAW,
            data: {
                data: data
            }
        },
        apiOptions: {
            headers: attachHeader(true),
            withCredentials: true
        }
    };
    return commonApi(request);
}